import { QUESTION_ID } from 'modules/questionnaire/questionIds';

const { biomarkers: BIOMARKERS_QUESTION_ID } = QUESTION_ID;

export default {
  biomarkers: BIOMARKERS_QUESTION_ID,
  drugs_received: 'drugs_received',
  drugs_combinations: 'drugs_combinations',
  insurances: 'insurances',
};
